import store from '../store/index'
let formatter = require('./Formatter')

let isTrue = formatter.FormatterUtils.methods.isTrue
export const homeButtonUtils = {
  data () {
    return {
      rowLayout: [
        [0],
        [1],
        [1, 1], // 2 elem
        [2, 1], // 3 elem
        [2, 2],
        [3, 2],
        [4, 2],
        [4, 3]
      ],
      cssClassPerRow: [
        [''],
        ['col-md-12'],
        ['col-md-12', 'col-md-12'],
        ['col-md-6', 'col-md-12'],
        ['col-md-6', 'col-md-6'],
        ['col-md-4', 'col-md-6'],
        ['col-md-3', 'col-md-6'],
        ['col-md-3', 'col-md-4']
      ],
      fieldsEn: {
        login: 'Login / Create New Account',
        register_as_a_new_patient: 'New Order',
        register_as_a_new_patient_guest: 'New Order As Guest',
        home_collection: 'Home Collection',
        check_your_results: 'Check your results',
        register_kit: 'Register Kit',
        go_pass: 'Go Pass',
        quick_order: 'Quick Order'
      },
      registerPath: store.state.configs['SINGLE_PAGE_ORDERS'] === true ? '/patient/order' : '/patient/register',
      homeCollectionPath: store.state.configs['SINGLE_PAGE_ORDERS'] === true ? '/patient/order-home-collection' : '/patient/register-home-collection'
    }
  },
  computed: {
    homeButtonsDetails () {
      return {
        login: {
          visible: store.state.configs['ALLOW_ACCOUNTS'],
          path: '/login',
          caption: this.fieldsEn['login'],
          image: 'login'
        },
        newOrder: {
          visible: this.allow_registration && this.display_new_order_guest,
          path: this.registerPath,
          caption: store.state.configs['ALLOW_ACCOUNTS'] ? this.fieldsEn['register_as_a_new_patient_guest'] : this.fieldsEn['register_as_a_new_patient'],
          image: 'newOrder'
        },
        homeCollection: {
          visible: this.allow_registration && this.display_home_collection,
          path: this.homeCollectionPath,
          caption: this.fieldsEn['home_collection'],
          image: 'homeCollection'
        },
        results: {
          visible: this.allow_results && this.display_results_guest,
          path: '/patient/check-results',
          caption: this.fieldsEn['check_your_results'],
          image: 'checkResults'
        },
        registerKit: {
          visible: this.allow_kit_registration && this.display_kit_guest,
          path: '/patient/kit',
          caption: this.fieldsEn['register_kit'],
          image: 'kit'
        },
        goPass: {
          visible: this.allow_go_pass && this.display_go_pass_guest,
          path: '/go-pass',
          caption: this.fieldsEn['go_pass'],
          image: 'goPass'
        },
        quickOrder: {
          visible: this.allow_quick_order && this.display_quick_order_guest,
          path: '/self-order',
          caption: this.fieldsEn['quick_order'],
          image: 'quickOrder'
        }
      }
    },
    allow_registration () {
      return isTrue(store.state.configs.ALLOW_REGISTRATION)
    },
    display_new_order_guest () {
      if (store.state.configs.DISPLAY_NEW_ORDER_GUEST === undefined) {
        return true
      }
      return isTrue(store.state.configs.DISPLAY_NEW_ORDER_GUEST)
    },
    display_home_collection () {
      if (store.state.configs.DISPLAY_HOME_COLLECTION === undefined) {
        return false
      }
      return isTrue(store.state.configs.DISPLAY_HOME_COLLECTION)
    },
    allow_results () {
      return isTrue(store.state.configs.ALLOW_RESULTS)
    },
    display_results_guest () {
      if (store.state.configs.DISPLAY_RESULTS_GUEST === undefined) {
        return true
      }
      return isTrue(store.state.configs.DISPLAY_RESULTS_GUEST)
    },
    allow_kit_registration () {
      return isTrue(store.state.configs.ALLOW_KIT_REGISTRATION)
    },
    display_kit_guest () {
      if (store.state.configs.DISPLAY_KIT_GUEST === undefined) {
        return true
      }
      return isTrue(store.state.configs.DISPLAY_KIT_GUEST)
    },
    allow_go_pass () {
      return isTrue(store.state.configs.ALLOW_GO_PASS)
    },
    display_go_pass_guest () {
      if (store.state.configs.DISPLAY_GO_PASS_GUEST === undefined) {
        return true
      }
      return isTrue(store.state.configs.DISPLAY_GO_PASS_GUEST)
    },
    allow_quick_order () {
      return isTrue(store.state.configs.ALLOW_SELF_ORDERING)
    },
    display_quick_order_guest () {
      if (store.state.configs.DISPLAY_QUICK_ORDER_GUEST === undefined) {
        return true
      }
      return isTrue(store.state.configs.DISPLAY_QUICK_ORDER_GUEST)
    }
  },
  methods: {
    checkVisibility () {
      const someTruthy = Object.values(this.homeButtonsDetails).some(val => val.visible === true)
      return someTruthy || store.state.configs['ALLOW_ACCOUNTS']
    },
    calculatePositionOnGrid (object, element) {
      let i
      let filteredArray = []
      for (const elem in object) {
        if (object[elem].visible) {
          filteredArray.push(elem)
        }
      }
      let key = filteredArray.indexOf(element) + 1
      this.rowLayout[filteredArray.length].every((element, idx) => {
        if (key > element) {
          key = key - element
          return true
        } else {
          i = idx
          return false
        }
      })
      return this.cssClassPerRow[filteredArray.length][i]
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/HomeButtons.js